import { useEffect, useState } from 'react'
import { LAYOUT_LAYOUT_MANAGER_TEXTS as T } from '../../shared/texts'

// „Vollbild“ in the top bar (Betreiber 03.11.2026, Vorgang backoffice-vollbild-knopf.md): the whole
// backoffice into the browser's fullscreen mode and back. Esc leaves it as usual; the button follows the
// state through fullscreenchange, however the mode ended. Where the browser offers no fullscreen
// (fullscreenEnabled false — iPhone Safari) the button is not there at all. Older Safari only knows the
// webkit-prefixed API, so both are covered.

type Doc = Document & {
    webkitFullscreenEnabled?: boolean
    webkitFullscreenElement?: Element | null
    webkitExitFullscreen?: () => Promise<void> | void
}
type El = HTMLElement & { webkitRequestFullscreen?: () => Promise<void> | void }

const doc = () => document as Doc
export const fullscreenSupported = () => !!(doc().fullscreenEnabled || doc().webkitFullscreenEnabled)
const isFullscreen = () => !!(doc().fullscreenElement || doc().webkitFullscreenElement)

async function toggle() {
    try {
        if (isFullscreen()) {
            if (doc().exitFullscreen) await doc().exitFullscreen()
            else await doc().webkitExitFullscreen?.()
        } else {
            const el = document.documentElement as El
            if (el.requestFullscreen) await el.requestFullscreen()
            else await el.webkitRequestFullscreen?.()
        }
    } catch { /* refused by the browser (no user gesture, policy) — the state simply stays */ }
}

export default function FullscreenButton() {
    const [on, setOn] = useState(isFullscreen)
    useEffect(() => {
        const sync = () => setOn(isFullscreen())
        document.addEventListener('fullscreenchange', sync)
        document.addEventListener('webkitfullscreenchange', sync)
        return () => {
            document.removeEventListener('fullscreenchange', sync)
            document.removeEventListener('webkitfullscreenchange', sync)
        }
    }, [])
    if (!fullscreenSupported()) return null
    const label = on ? T.fullscreenExit : T.fullscreenEnter
    return (
        <button type="button" className="hamburger topbar-fullscreen" title={label} aria-label={label} aria-pressed={on}
            onClick={() => { void toggle() }}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}
                strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                {on
                    ? <><polyline points="4 14 10 14 10 20" /><polyline points="20 10 14 10 14 4" /><line x1="14" y1="10" x2="21" y2="3" /><line x1="3" y1="21" x2="10" y2="14" /></>
                    : <><polyline points="15 3 21 3 21 9" /><polyline points="9 21 3 21 3 15" /><line x1="21" y1="3" x2="14" y2="10" /><line x1="3" y1="21" x2="10" y2="14" /></>}
            </svg>
        </button>
    )
}
